import { useQueryClient, useMutation } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import AuthDataService from 'src/services/auth.service'
import { ISend2FAVerificationEmailDto } from 'src/types'

export const useSendLogin2FAVerificationEmail = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (dto: ISend2FAVerificationEmailDto) => AuthDataService.send2FAVerificationEmail(dto),
    {
      onSuccess: (data) => {
        if (!data) return

        queryClient.invalidateQueries([QUERY_KEYS.AUTH_USER_2FA_EMAIL_TIME])
        queryClient.invalidateQueries([QUERY_KEYS.AUTH_TOKEN])
      },
    },
  )
}
